import Dexie from 'dexie';
import { CacheSitePanels } from 'solar-bo';;




export class SolarDatabase extends Dexie {
    sitepanels: Dexie.Table<CacheSitePanels, string>;
    constructor() {
        super("SolarDatabase");
        let db = this;
        //
        // Define tables and indexes
        //
        db.version(1).stores({
            sitepanels: '++id, panels',
        });
        // Let's physically map SitePanels class to SitePanels table.
        db.sitepanels.mapToClass(CacheSitePanels);
    }
}
